import React, { Fragment } from "react";
import { userData } from "../../data";
import Footer from "../Layout/Footer/Footer";
import Header from "../Layout/Header/Header";

const TermsOfUse = () => {
  return (
    <Fragment>
      
      <section>
      <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
          <h1>Trust IT Terms of Use</h1>

          <section>
            <h2>Website Operator</h2>
            <p>
              This Website is run by Trust IT (referred to below as “we”, “us”
              or “our”).
            </p>
            <p>
              Trust IT Patient app, Trust IT Doctors app, Trust IT Report app,
              Anaesmon is a brand name of medical software produced by
              Bangladesh Electronic Medical Records (Trust IT), a company
              registered in Canada (company registration number BC1045871) with
              registered offices at 8505 Wildwood Pl, Surrey, BC, V4N5C5. We are
              a private company.
            </p>
          </section>

          <section>
            <h2>Application of Terms of Use</h2>
            <p>
              These “Terms of Use” tell you the terms of use on which you may
              make use of our website{" "}
              <a href="https://trustitworld.com.bd">
                https://trustitworld.com.bd
              </a>{" "}
              (the “Website”), or the app as a registered user.
            </p>
            <p>
              Please read these Terms of Use carefully before you start to use
              our Website, or app as these will apply to your use of our
              Website.
            </p>
            <p>
              By using our Website, app/apps, you confirm that you accept these
              Terms of Use and that you agree to comply with them.
            </p>
          </section>

          <section>
            <h2>Accessing the Website</h2>
            <p>
              We do not guarantee that our Website, app/apps, or any content on
              it, will always be available or be uninterrupted. Access to our
              Website is permitted on a temporary basis. We may suspend,
              withdraw, discontinue or change all or any part of our Website
              without notice. We will not be liable to you if for any reason our
              Website is unavailable at any time or for any period.
            </p>
            <br />
            <p>
              You are responsible for making all arrangements necessary for you
              to access our Website, app/apps (including, having access to an
              internet connection and an appropriate browser).
            </p>
            <br />
            <p>
              You are also responsible for ensuring that all persons who access
              our Website, app/apps through your internet connection are aware
              of these Terms of Use and other applicable terms and conditions,
              and that they comply with them.
            </p>
          </section>

          <section>
            <h2>Prohibited Uses</h2>
            <p>
              You may use our Website only for lawful purposes. You may not use
              our Website:
            </p>
            
              <li>
                {" "}
                In any way that breaches any applicable local, national or
                international law or regulation
              </li>
              <li>
                to access any information not pertaining to you , or any
                information which belongs to any person other than you
              </li>
              <li>
                {" "}
                In any way that is unlawful or fraudulent, or has any unlawful
                or fraudulent purpose or effect.
              </li>
              <li>
                {" "}
                To send, knowingly receive, upload, download, use or re-use any
                material which does not comply with our content standards (as
                set out below).
              </li>
              <li>
                To transmit, or procure the sending of, any unsolicited or
                unauthorised advertising or promotional material or any other
                form of similar solicitation (spam).
              </li>
              <li>
                To knowingly transmit any data, send or upload any material that
                contains viruses, Trojan horses, worms, time-bombs, keystroke
                loggers, spyware, adware or any other harmful programs or
                similar computer code designed to adversely affect the operation
                of any computer software or hardware.
              </li>
            
          </section>

          <section>
            <h2>Disclaimers</h2>
            <p>
              The Website, app/apps contains content generated by us (or on our
              behalf by medical authors). The content on our Website, app/apps
              is provided for general information only. It is not intended to
              amount to advice on which you should rely. In particular, this
              information is not a substitute for professional medical care by a
              qualified doctor or other healthcare professional. Also this
              information is not a substitute for professional medical knowledge
              required by the physician. If you are not a healthcare
              professional then you should ALWAYS check with your doctor if you
              have any concerns about your condition or treatment and before
              taking, or refraining from, any action on the basis of the content
              on our Website, app/apps.If you are a healthcare professional then
              this information (including any professional reference material)
              is intended to support,not replace, your own knowledge, experience
              and judgement.
            </p>
            <br />
            <p>
              Not all medical resources on the internet are authoritative or
              current. Any decision about your health or medical care based
              solely on information obtained from the internet could be
              dangerous. Whilst we hope that you will find the third party sites
              linked (if any) to of interest, we can accept no responsibility in
              respect of any third party web sites or any information contained
              therein.
            </p>
            <br />
            <p>
              The information contained in the Website, app/apps may contain
              technical inaccuracies or typographical errors. We reserve the
              right to make changes and improvements to any information
              contained within the Website, app/apps, at any time and without
              notice.
            </p>
            <br />
            <p>
              Although we make reasonable efforts to update the information on
              our Website, we make no representations, warranties or guarantees,
              whether express or implied, that the content on our Website is
              accurate, complete or up-to-date. We also do not warrant or
              represent that the information or materials available through the
              Website will meet your particular requirements or needs or that
              access to, or use of, the same will be uninterrupted or completely
              secure.
            </p>
            <br />
            <p>
              Medical tips are the authority of the writers. Though providing
              correct information is the responsibility of the author, the
              health tip do not replace a professional help. Tips are intended
              to create awareness, not to provide accurate medical information
              to be used without consulting appropriate medical professional.
            </p>
            <br />
            <p>
              We do not endorse any specific products, processes, service
              providers, diets, or other information that may be mentioned on
              our Website (including, those promoted by any advertisers or
              advertising sponsors).
            </p>
          </section>

          <section>
            <h2>Intellectual Property Rights</h2>
            <p>
              We are the owner (or the licensee) of all intellectual property
              rights in our Website, and in the material published on it. Those
              works are protected by copyright laws and treaties around the
              world. All such rights are reserved.
            </p>
            <br />
            <p>
              You may download and/or print off your own personal information
              from our Website for your personal use. and you may (in a
              non-commercial context) draw the attention of others to content
              posted on our Website.
            </p>
            <br />
            <p>
              You must not modify the paper or digital copies of any materials
              you have printed off or downloaded in any way, and you must not
              further use any illustrations, photographs, video or audio
              sequences or any graphics separately from any accompanying text.
            </p>
            <br />
            <p>
              You must not do the same to any content which does not belong to
              you or infringe on any other person’s right and confidentiality.
            </p>
            <br />
            <p>
              Our status (and that of any identified contributors) as the
              authors of content on our Website must always be acknowledged. Any
              information other than yours own, or your own patient as a
              helathcare pofessional, should be accessed, shared, reproduced or
              modified.
            </p>
            <br />
            <p>
              You must not use any part of the content on our Website, app/apps
              for commercial purposes without obtaining a licence to do so from
              us (or our licensors as appropriate).
            </p>
            <br />
            <p>
              If you print off, copy or download any part of our Website,
              app/apps in breach of these Terms of Use, your right to use our
              Website, app/apps will cease immediately and you must, at our
              option, return or destroy any copies of the materials you have
              made (for the avoidance of doubt, these Terms of Use shall
              continue to apply in respect of any such materials).
            </p>
            <br />
          </section>

          <section>
            <h2>Registering for an Account</h2>
            <br />
            <p>
              If you choose to register for an account with our Website then if
              you select, or you are provided with, a user identification
              code,an email, password or any other piece of information as part
              of our registration or security procedures, you must treat such
              information as confidential. You must not disclose it to any third
              party.
            </p>
            <br />
            <p>
              We have the right to disable any user identification code or
              password, whether chosen by you or allocated by us, at any time,
              if in our reasonable opinion you have failed to comply with any of
              the provisions of these Terms of Use.
            </p>
            <br />
            <p>
              If you know or suspect that anyone other than you knows your user
              identification code or password, you must promptly reset your
              password to something which only you know (please
              visithttps://trustitworld.com.bd/).
            </p>
            <br />
            <p>
              You can retrieve, change or request that we delete the details you
              place with us. You will only receive emails that you have agreed
              to, or those relating to administration purposes. We will not
              provide your personal data to any third party for any commercial
              purposes.
            </p>
            <br />
            <p>
              You must only use the Website for lawful purposes and you must not
              infringe the rights of other users of this site or prevent their
              enjoyment of it.
            </p>
            <br />
            <p>
              {" "}
              If you are under 16 you need to get permission from a parent or
              guardian before providing us with any personal details. The use of
              any of our interactive services by a minor is subject to the
              consent of their parent or guardian. We advise parents who permit
              their children to use an interactive service that it is important
              that they communicate with their children about their safety
              online, as moderation is not foolproof. Minors who are using any
              interactive service should be made aware of the potential risks to
              them.
            </p>
          </section>

          <section>
            <h2>Contributions to our Website</h2>
            <br />
            <p>
              If you submit any contribution to this Website, app/apps via the
              medical information or health tips(including any text,
              photographs, graphics, video or audio) then such content will be
              considered non-confidential and non-proprietary. You retain all of
              your ownership rights in your content, but you are required to
              grant us a perpetual, royalty-free, non-exclusive, right to store,
              modify (where reasonably necessary to allow publication), copy and
              publish the contribution on the Website and to make it available
              to third parties. If you wish to keep your content confidential or
              do not want to grant us these rights, then please do not submit
              your contribution to theMedical tips.
            </p>
            <br />
            <p>
              Furthermore, by submitting your contribution to the
              Website,app/apps, you warrant that you have the right to make it
              available to us for all the purposes specified above; it is not
              defamatory; it does not infringe any law or third party rights;
              that it has not been copied from any third party and you will be
              required to reimburse us in respect of all legal fees, damages and
              other expenses that we may incur as a result of your breach of the
              above warranty.
            </p>
            <br />
            <p>
              {" "}
              We have the right to disclose your identity to any third party who
              is claiming that any content posted or uploaded by you to our site
              constitutes a violation of their intellectual property rights, or
              of their right to privacy.
            </p>
            <br />
            <p>
              We will not be responsible, or liable to any third party, for the
              content or accuracy of any content posted by you or any other user
              of our Website, app/apps.
            </p>
            <br />
            <p>
              We have the right to remove any posting you make on our Website
              if, in our opinion, your post does not comply with the content
              standards set out in these Terms of Use.
            </p>
          </section>
          <section>
            <h2>Third Party Links and Resources in our Website</h2>
            <br />
            <p>
              This Website may contain links to other websites and resources
              operated by third parties. These links are provided for your
              reference only. We do not control such websites or resources and
              are not responsible for their availability or content.
            </p>
            <br />
            <p>
              Our inclusion of links to such websites does not imply any
              endorsement of the material on such websites or any association
              with their operators.
            </p>
            <br />
            <p>
              Where our site contains links to other sites and resources
              provided by third parties, these links are provided for your
              information only.
            </p>
            <br />
            <p>
              We have no control over the contents of those sites or resources.
            </p>
          </section>
          <section>
            <h2>Linking to our Website</h2>
            <br />
            <p>
              You may link to the Website, provided you do so in a way that is
              fair and legal and does not damage our reputation or take
              advantage of it. ( this clause will be at the discretion of the
              Website, app/apps).
            </p>
            <br />
            <p>
              You must not establish a link in such a way as to suggest any form
              of association, approval or endorsement on our part where none
              exists. Our Website must not be framed on any other site.
            </p>
            <br />
            <p>
              We reserve the right to withdraw linking permission without
              notice.
            </p>
            <br />
            <p>
              If you wish to make any use of content on our Website other than
              that set out above, please contact us using this
              form:https://trustitworld.com.bd/
            </p>
          </section>
          <section>
            <h2>LIMITATIONS OF LIABILITY</h2>
            <h3>
              Please read this section carefully as it sets out the limits of
              our liability to you in relation to your use of the Website.
            </h3>

            <br />
            <p>
              Nothing in these Terms of Use excludes or limits our liability for
              death or personal injury arising from our negligence, or our fraud
              or fraudulent misrepresentation, or any other liability that
              cannot be excluded or limited law of the land
            </p>
            <br />
            <p>
              To the extent permitted by law, we exclude all conditions,
              warranties, representations or other terms which may apply to our
              Website, app/apps or any content on it, whether express or implied
            </p>
            <br />
            <p>
              We will not be liable to any user for any loss or damage, whether
              in contract, tort (including negligence or breach of statutory
              duty), or otherwise, even if foreseeable, arising under or in
              connection with:
            </p>
            <br />
            <li>
              <ul>use of, or inability to use, our Website, app/apps; or</ul>
              <ul>
                use of or reliance on any content displayed on our Website
                (regardless of the origins of such content).
              </ul>
            </li>
            <p>
              Please note that we only provide our Website for domestic and
              private use (and as a auxiliary tool for use by healthcare
              professionals). You agree not to use our site for any commercial
              or business purposes, and we have no liability to you for any loss
              of profit, loss of business, business interruption, or loss of
              business opportunity.
            </p>
            <br />
            <p>
              We assume no responsibility for the content of websites linked on
              our Website, app/apps,if any. Such links should not be interpreted
              as endorsement by us of those linked websites. We will not be
              liable for any loss or damage that may arise from your use of
              them.
            </p>
            <br />
            <p>
              We use our reasonable efforts to check the accuracy of the
              professional information published on this Website.You should note
              however that we do not warrant that such information will be error
              free and you acknowledge that the information, products, and
              services published on this Website may include inaccuracies or
              typographical errors.Changes are periodically added to the
              information herein.
            </p>
            <br />
            <p>
              We (and/or our suppliers) make no representations about the
              suitability of the information, products, and services contained
              on this Website for any purpose.
            </p>
            <br />
            <p>
              {" "}
              Subject to the first paragraph under this section (Limitations of
              Liability), in no event shall we (or any of our suppliers or
              licensors) be liable to you whether in contract, tort (including
              negligence or breach of statutory duty), or otherwise, for any,
              indirect, incidental, special, or consequential damages arising
              out of or in any way connected with the use of this Website,
              app/apps or with the delay or inability to use this Website,
              app/apps, or for any information, products, and services obtained
              through this Website, app/apps, or otherwise arising out of the
              use of this Website, app/apps, even if we or any of our suppliers
              has been advised of the possibility of such damages arising.
            </p>
            <br />
            <p>
              Subject to the first paragraph under this section (Limitations of
              Liability), our liability (and that of our suppliers or licensors)
              for any losses suffered arising out of, or in connection with,
              your use of this Website, app/apps, whether in contract, tort
              (including negligence or breach of statutory duty), or otherwise
              is limited to the greater of: (i) the total value of the relevant
              transaction (if any) under which the claim arises for any one
              event or series of connected events, or (ii) the sum of ten
              thousand taka ( Tk 10,000).
            </p>
            <br />
            <p>
              We will not be liable for any loss or damage caused by a virus,
              distributed denial-of-service attack, or other technologically
              harmful material that may infect your computer equipment, computer
              programs, data or other proprietary material due to your use of
              our Website or to your downloading of any content on it, or on any
              website linked to it.
            </p>
            <br />
            <h6>
              This does not affect any legal rights you may have as a consumer.
            </h6>
            <br />
            <p>
              You acknowledge that we have made the Website available to you in
              reliance upon these Terms of Use and in particular these
              Limitations of Liability.
            </p>
          </section>

          <section>
            <h2>Breach of these Terms of Use</h2>
            <p>
              If you fail to abide by these Terms of Use when using this
              Website, you may be sent an e-mail which informs you why your
              contribution to the Website has been rejected or edited. This mail
              will also include a warning that continuing to break the rules may
              result in action being taken against your account or accounts. In
              certain cases, at total discretion to us, your access may be
              denied temporarily or permanently even without sending any email
              or notice.
            </p>
            <br />
            <p>
              This action may include your relevant account or accounts being
              placed into pre-moderation or a temporary or permanent suspension
              of your ability to log on to the Website, app/apps.
            </p>
            <br />
            <p>
              If you post or send offensive or inappropriate content to this
              Website, app/apps or otherwise engage in any disruptive behaviour
              on the Website, and Patient or its representatives consider such
              behaviour to be serious and/or repeated, Patient may use whatever
              information that is available to it about you to stop any further
              such infringements. This may include informing relevant third
              parties such as your employer, email provider or legal authorities
              about the infringement/s.
            </p>
            <br />
            <p>
              Patient reserves the right to delete any contribution, or take
              action against any account, at any time, for any reason.
            </p>
          </section>

          <section>
            <h2>Collection of Personal Data</h2>
            <p>
              If you register to use any app produced by Trust IT Solutions Corp.,
              the Services may collect personal data about you, including
              without limitation your name,, age, medical conditions and a valid
              email address from you when you register to use these services.
              This data will be securely held in accordance with the terms of
              our Privacy Policy (seehttps://trustitworld.com.bd/privacy-policy).
            </p>
            <br />
            <p>
              Notwithstanding anything to the contrary Trust ITmay also hold your
              name and details in relation to assisting us in the provision of
              thedifferent app/apps Services and associated services. We shall
              at all times remain responsible to you for the treatment and use
              of data submitted via the Website which is held by Trust IT.
            </p>
          </section>

          <section>
            <h2>Viruses</h2>
            <br />
            <p>
              We do not guarantee that our Website, app/apps will be secure or
              free from bugs or viruses and you should use your own virus
              protection software.
            </p>
            <br />
            <p>
              You must not misuse our Website, app/apps by knowingly introducing
              viruses, trojans, worms, logic bombs or other material which is
              malicious or technologically harmful. You must not attempt to gain
              unauthorised access to our Website, the server on which our
              Website is stored or any server, computer or database connected to
              our Website. You must not attack our Website via a
              denial-of-service attack or a distributed denial-of service
              attack. By breaching this provision, you may be committing a
              criminal offence under the Computer Misuse Act 1990. We will
              report any such breach to the relevant law enforcement authorities
              and we will co-operate with those authorities by disclosing your
              identity to them. In the event of such a breach, your right to use
              our Website will cease immediately.
            </p>
          </section>

          <section>
            <h2>Choice of Law and Jurisdiction</h2>
            <p>
              Please note that these Terms of Use, its subject matter and its
              formation, are governed by Law of the Bangladesh even if this
              software is used in other countries. If there is any legal action,
              it should be dealt in Bangladesh
            </p>
            <br />
            <p>
              This Website is intended for use by persons resident within
              Bangladesh. If you are accessing this Website from any other
              location then: (i) we make no representations that the content of
              this Website will be suitable for your requirements or that it is
              permissible or legal for you to access the same; and (ii) your use
              of the Website is entirely at your own risk and you are
              responsible for ensuring that you act in accordance with any
              applicable laws.
            </p>
            <br />
            <p>
              Use of this Website is unauthorised in any jurisdiction that does
              not give effect to all provisions of these Terms of Use, including
              without limitation this paragraph.
            </p>
          </section>
          <section>
            <h2>General</h2>
            <br />
            <p>
              We reserve the right to change these Terms of Use (and any other
              terms, conditions, and notices) under which this Website, app/apps
              is offered.
            </p>
            <br />
            <p>
              If any part of these Terms of Use is determined to be invalid or
              unenforceable pursuant to applicable law including, but not
              limited to, the warranty disclaimers and liability limitations set
              forth above, then the invalid or unenforceable provision will be
              deemed superseded by a valid, enforceable provision that most
              closely matches the intent of the original provision and the
              remainder of the agreement shall continue in effect.
            </p>
            <br />
            <p>
              Any provision of these Terms of Use that expressly or by
              implication is intended to come into or continue in force on or
              after termination of your right to use the Website, app/apps shall
              remain in full force and effect, including, any license granted by
              you in respect of any uploaded content and the provisions of the
              section titled Limitations of Liability.
            </p>
            <br />
            <p>
              We will not be in breach of any of our obligations under these
              Terms of Use (or otherwise liable for any failure or delay in
              performance) if we are prevented, hindered or delayed in or from
              performing any of our obligations by any event beyond our
              reasonable control. The time for performance of such obligations
              shall be extended accordingly.
            </p>
            <br />
            <p>
              Subject to any specific terms detailed on the Website, app/apps in
              relation to particular features or materials, these Terms of Use
              (together with the Privacy Policy and Cookie Policy) set out the
              entire agreement between you and us in respect of your use of the
              Website.
            </p>
            <br />
            <p>
              No failure or delay by us to exercise any right or remedy provided
              under these Terms of Use or by law shall constitute a waiver of
              that or any other right or remedy, nor shall it prevent or
              restrict the further exercise of that or any other right or
              remedy. No single or partial exercise of such right or remedy
              shall prevent or restrict the further exercise of that or any
              other right or remedy.
            </p>
            <br />
            <p>Any rights not expressly granted herein are reserved.</p>
            <br />
            <p>
              Trust IT Solutions Corp. may choose to alter this document at any
              given time with or without prior notice to those affected.
            </p>
          </section>

          <section>
            <h2>Contact Us</h2>
            <p>
              To contact us, please use the contact/feedback form accessible via
              this link{" "}
              <a href="https://trustitworld.com.bd">
                https://trustitworld.com.bd
              </a>
            </p>
          </section>

          <footer>
            <p>Last updated: 06th June 2016</p>
          </footer>
        </div>
      </section>
    </Fragment>
  );
};

export default TermsOfUse;
